<template>
  <div :class="`checkpoint${disabled ? '' : ' checkpoint__link_style'}`">
    <div :class="`checkpoint__icon ${status}`"></div>
    <div class="checkpoint__label">
      <slot></slot>
    </div>
    <div class="checkpoint__indicators-block">
      <indicators-block v-if="isShowingIndicators">
        <indicator-item
          v-if="isShowingVolunteering"
          :type="getVolunteeringIndicatorType()"
        >
          В
        </indicator-item>
        <indicator-item
          v-if="isShowingCompetencies"
          :type="getCompetencyIndicatorType()"
        >
          К
        </indicator-item>
      </indicators-block>
    </div>
  </div>
</template>

<script setup>
  /**
   * Компонент контрольной точки по задаче.
   * TODO: перенести в папку к остальным компонентам, которые относятся к контрольным точкам.
   * На дату 04.07.2025 это папка components/projects/management/CheckPoints
   */
  import {
    CHECKPOINT_COMPETENCE_SET_STATUS_CONFIRMED,
    CHECKPOINT_COMPETENCE_SET_STATUS_DEFAULT,
    CHECKPOINT_COMPETENCE_SET_STATUS_REJECTED,
  } from '@/constants/checkpoint-competence-set';
  import {
    VOLUNTEERING_PERIOD_STATUS_APPROVED,
    VOLUNTEERING_PERIOD_STATUS_DECRALED,
  } from '@/constants/volunteering-period';
  import {
    INDICATOR_ITEM_TYPE_APPROVED,
    INDICATOR_ITEM_TYPE_DECLARED,
    INDICATOR_ITEM_TYPE_REJECTED,
  } from '../indicator/constants/indicator-item';
  import { useStore } from 'vuex';
  import IndicatorsBlock from '../indicator/components/IndicatorsBlock.vue';
  import IndicatorItem from '../indicator/components/IndicatorItem.vue';
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { USER_ROLE_LEADER } from '@/api/models/UserRole';

  const route = useRoute();
  const store = useStore();

  const props = defineProps({
    status: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    competenceStatus: [String, null], // TODO: заменить на числовые статусы
    volunteeringStatus: [Number, null],
  });

  // показывать индикаторы только для руководителя проекта
  const isShowingIndicators = computed(() => {
    return USER_ROLE_LEADER === route.meta.role;
  });

  const isShowingVolunteering = computed(() => {
    const showingWhen = [
      VOLUNTEERING_PERIOD_STATUS_DECRALED,
      VOLUNTEERING_PERIOD_STATUS_APPROVED,
    ];

    return showingWhen.includes(props.volunteeringStatus);
  });

  const isShowingCompetencies = computed(() => {
    if (!store.getters.enableCompetencies) {
      return false;
    }

    const showingWhen = [
      CHECKPOINT_COMPETENCE_SET_STATUS_DEFAULT,
      CHECKPOINT_COMPETENCE_SET_STATUS_CONFIRMED,
      CHECKPOINT_COMPETENCE_SET_STATUS_REJECTED,
    ];

    return showingWhen.includes(props.competenceStatus);
  });

  const getVolunteeringIndicatorType = () => {
    if (VOLUNTEERING_PERIOD_STATUS_DECRALED === props.volunteeringStatus) {
      return INDICATOR_ITEM_TYPE_DECLARED;
    }

    if (VOLUNTEERING_PERIOD_STATUS_APPROVED === props.volunteeringStatus) {
      return INDICATOR_ITEM_TYPE_APPROVED;
    }

    return undefined;
  };

  const getCompetencyIndicatorType = () => {
    if (!store.getters.enableCompetencies) {
      return undefined;
    }

    if (CHECKPOINT_COMPETENCE_SET_STATUS_DEFAULT === props.competenceStatus) {
      return INDICATOR_ITEM_TYPE_DECLARED;
    }

    if (CHECKPOINT_COMPETENCE_SET_STATUS_CONFIRMED === props.competenceStatus) {
      return INDICATOR_ITEM_TYPE_APPROVED;
    }

    if (CHECKPOINT_COMPETENCE_SET_STATUS_REJECTED === props.competenceStatus) {
      return INDICATOR_ITEM_TYPE_REJECTED;
    }

    return undefined;
  };
</script>

<style lang="scss">
  @use '@/assets/styles/_colors.scss' as *;

  .checkpoint__link_style {
    cursor: pointer;
  }

  .checkpoint {
    align-items: center;
    display: flex;
    gap: 15px;

    &__icon {
      background-color: $color-bg-primary-white;
      border: 1px solid $color-input;
      border-radius: 2px;
      display: block;
      height: 16px;
      width: 16px;
      min-width: 16px;
      transition: all 0.3s;

      &.completed {
        background: center no-repeat url('@/assets/icons/done.svg'),
          $color-bg-status-done;
        border: 0;
      }

      &.completed-overdue {
        background: center no-repeat url('@/assets/icons/done.svg'),
          $color-bg-status-expired;
        border: 0;
      }

      &.incomplete-overdue {
        background: center no-repeat url('@/assets/icons/cross.svg'),
          $color-bg-status-reject;
        border: 0;
      }
    }

    &__label {
      color: $color-bg-status-new;
      font: 400 14px/20px 'Nunito Sans';
    }
  }
</style>
